module.exports = __webpack_public_path__ + "static/climate_card_img2@2x-fc09b5ba472468adeee94a228a3998b0.jpg";